export const locationDropDownStyles = {
    menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
    container: (provided) => ({
        ...provided,
        fontFamily: "'Montserrat', sans-serif",
        marginLeft: '6px',
        zIndex: '3'
    }),
    control: (provided) => ({
        ...provided,
        borderRadius: '8px',
        height: '40px',
        minHeight: '32px',
        paddingBottom: '5px',
        backgroundColor: '#EBF7FD',
        border: 'none',
    }),
    placeholder: (provided) => ({
        ...provided,
        paddingTop: '5px',
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        paddingTop: '8px',
        color: '#006D9E',
        '& svg': {
            opacity: '0.6'
        },
        '&:hover': {
            color: '#006D9E',
        }
    }),
    clearIndicator: (provided) => ({
        ...provided,
        marginTop: '-6px',
    }),
    indicatorSeparator: (provided) => ({
        ...provided,
        display: 'none',
    }),
    option: (provided, state) => ({
        ...provided,
        fontFamily: "'Montserrat', sans-serif",
        paddingTop: '1px',
        paddingBottom: '1px',
        backgroundColor: state.isFocused ? '#0D6EFD' : '#ffffff',
        color: state.isFocused ? '#ffffff' : '#222222',
        '&:hover': {
            backgroundColor: state.isFocused ? '#0D6EFD !important' : '#ffffff',
            color: state.isFocused ? '#ffffff' : '#222222',
            outline: 0,
        }
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        position: 'absolute',
        right: '20px',
        top: '50%',
        transform: 'translateY(-50%)',
    }),
    menu: (provided) => ({
        ...provided,
        marginTop: '40px',
        minWidth: '100%',
    }),
    menuList: (provided) => ({
        ...provided,
        width: '100%',
    }),
    valueContainer: (provided) => ({
        ...provided,
        paddingTop: '4px',
        width: "100%",
        marginRight: "50px",
        position: 'static'
    }),
    singleValue: (provided) => ({
        ...provided,
        whiteSpace: 'unset',
        overflow: 'visible',
        paddingTop: '5px',
        fontWeight: "500",
        color: "#006D9E",
        paddingLeft: '15px',
        letterSpacing: '0.3px'
    }),
};
